import { useContext } from 'react';
import { StageContext } from '../stage-provider';
const useStage = () => {
  return useContext(StageContext);
};
export default useStage;